import {
  // FaFacebookF,
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  // FaTwitter,
  FaWhatsapp,
} from "react-icons/fa"

export const MediaList = [
  {
    id: 4,
    label: "Linkedin",
    href: "https://www.linkedin.com/in/daksh-patel-3a7ba9215/",
    icon: FaLinkedinIn,
  },
  // {
  //   id: 1,
  //   label: "Facebook",
  //   href: "https://www.facebook.com/daksh.patel.5015983",
  //   icon: FaFacebookF,
  // },
  {
    id: 2,
    label: "GitHub",
    href: "https://github.com/Daksh-Patel",
    icon: FaGithub,
  },
  {
    id: 3,
    label: "Instagram",
    href: "https://www.instagram.com/_.dakshu15._/",
    icon: FaInstagram,
  },

  {
    id: 5,
    label: "Whatsapp",
    href: "https://wa.me/919173186323",
    icon: FaWhatsapp,
  },
  // {
  //   id: 6,
  //   label: "Twitter",
  //   href: "https://twitter.com/pateldaksh1520",
  //   icon: FaTwitter,
  // },
]
